import React from 'react';
import { TextField } from 'rmwc/TextField';
import moment from 'moment';

export class TimeSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectorOpen: false,
      timeStr:this.props.time,
      isValid:true
    }
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this._updateTime = this._updateTime.bind(this);
  }
/*
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
*/
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
       this.setState({selectorOpen:false});
    }
  }

  setWrapperRef(node) {
      this.wrapperRef = node;
  }

  onChange = date => {
    this.setState({calenderOpen:false});
    this.props.onChange(date);
  }

  _updateTime(time) {
    const isValid = moment(time, "h:mm a", true).isValid();
    this.setState({
      'timeStr': time,
      'isValid': isValid
    });
    if (isValid) {
      this.props.onChange(time);
    }
  }

  handleChange(e) {
    const target = e.target;
    this._updateTime(target.value);
  }

  isValid() {
    return (this.state.isValid)?"black":"red";
  }

  render() {
    return (
      <div ref={this.setWrapperRef}>
        <TextField
          style={{width:"65px", color:this.isValid()}}
          label={this.props.label}
          value={this.state.timeStr}
          onChange={e => this.handleChange(e)}
        />
      </div>
    )
  }
}


/*

export class TimeSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectorOpen: false
    }
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
       this.setState({selectorOpen:false});
    }
  }

  setWrapperRef(node) {
      this.wrapperRef = node;
  }

  onChange = date => {
    this.setState({calenderOpen:false});
    this.props.onChange(date);
  }

  _parseTime(time) {
    var currentDate = new Date(this.props.time);
    var regEx = new RegExp(/((1[0-2]|0?[1-9]):([0-5][0-9]) ([ap][m]))/g);
    var match = regEx.exec(time);

    if (match === null) return time;

    const minutes = match[3];
    const hours = (match[4]==="pm")?Number(match[2])+12:match[2];
    return new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), hours, minutes, 0);
  }

  handleChange(e) {
    const target = e.target;
    console.log(target.value)
    this.props.onChange(this._parseTime(target.value));
  }

  onSelect(e) {
    this.setState({selectorOpen:false});
    this.props.onChange(this._parseTime(e));
  }

  renderValidTimes() {
    var times = getValidTimes(this.props.time, 30);
    var items = [];
    for (var i = 0; i < times.length; i++) {
      var item = times[i];
      items.push(<div key={item} onClick={this.onSelect.bind(this, item)}>{item}</div>);
    }
    return items;
  }

  render() {
    return (
      <div ref={this.setWrapperRef}>
        <TextField
          style={{width:"65px"}}
          label="From"
          value={new Date(this.props.time).hhmmtt()}
          onClick={e => this.setState({'selectorOpen': !this.state.selectorOpen})}
          onChange={e => this.handleChange(e)}
        />
        {(this.state.selectorOpen)
        ?
        <div style={{zIndex:"1000", position:'absolute', maxHeight: "100px", overflow:"hidden", backgroundColor:"white"}} >
          <div style={{position: "relative", overflowY:"scroll", maxHeight:"100px"}}>
          {this.renderValidTimes()}
          </div>
        </div>
        :
        null}
      </div>
    )
  }
}

export function timeBlockLine(startTime, i, minOffset) {
  const offsetInMilliSeconds = i*60*minOffset*1000;
  return new Date(new Date(startTime).getTime() + offsetInMilliSeconds).hhmmtt();
}

export function getValidTimes(time, minOffset) {
  if (!time) throw new Error("Time argument is empty");

  const timeVar = new Date(time);

  const startTime = timeVar.ceiling(minOffset, 'minutes');
  const stopTime = timeVar.ceiling(1, 'day');

  const timeBlocksLeft = new Date(startTime).divisions(stopTime, minOffset, 'minutes');

  let validTimes = [];
  for (var i = 0; i < timeBlocksLeft; i++) {
    validTimes.push(timeBlockLine(startTime, i, minOffset));
  }

  return validTimes;
}
*/



// WEBPACK FOOTER //
// ./src/components/TimeSelector.js